// extracted by mini-css-extract-plugin
module.exports = {"custom-tooltip":"AiShortcut_custom-tooltip__O4MkG","custom-wrapper":"AiShortcut_custom-wrapper__N56Pr","react-tooltip-lite-arrow":"AiShortcut_react-tooltip-lite-arrow__IktUz"};